<template>
  <ElInputWrapper>
    <BaseElSelect
      v-model="syncModel"
      :filterable="filterable"
      remote
      :multiple="multiple"
      :clearable="clearable"
      v-bind="$attrs"
      reserve-keyword
      no-match-text="無匹配項目"
      no-data-text="暫無數據"
      :value-key="valueKey"
      style="height: 100%;"
      @remove-tag="$emit('removeTag', $event)"
      @visible-change="$emit('visibleChange', $event)"
      @change="$emit('change', $event)"
      @clear="$emit('clear', $event)"
    >
      <i slot="prefix" class="el-input__icon el-icon-search" />
      <BaseElSelectOption
        v-for="(item, index) in dataList"
        :key="`${index} - ${item[labelKey]}`"
        :label="item[labelKey]"
        :value="getValue(item)"
      />
    </BaseElSelect>
  </ElInputWrapper>
</template>
<script>
import { useVModel } from '@vueuse/core'
import ElInputWrapper from '../ElInputWrapper.vue'

export default {
  name: 'BaseDataSelect',
  components: {
    ElInputWrapper,
  },
  props: {
    value: [String, Number, Array, Object, Boolean, null],
    objKey: String,
    multiple: Boolean,
    clearable: {
      type: Boolean,
      default: true,
    },
    labelKey: {
      type: String,
      default: 'name',
    },
    valueKey: {
      type: String,
      default: 'id',
    },
    filter: {
      type: Object,
      default: () => ({}),
    },
    dataList: {
      type: Array,
      default: () => [],
    },
    filterable: {
      type: Boolean,
      default: true,
    },
  },
  setup (props, { emit }) {
    const syncModel = useVModel(props, 'value', emit)

    return { syncModel }
  },

  methods: {
    getValue (item) {
      if (this.objKey) return item[this.objKey]
      else return item
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep .el-select  {
  height: 100% !important;
}
::v-deep .el-input  {
  height: 100% !important;
}

::v-deep .el-select__tags {
@apply flex-nowrap;
}

::v-deep .el-select__tags .el-tag {
  @apply max-w-[120px];
}
</style>
